import AXIOS from "@/api";

export default {
  async getActiveMatches({ commit }) {
    try {
      const response = await AXIOS.get("v2/match/all", { params: {} });
      if (response.status === 200 && response.data.success) {
        commit('SET_MATCH_GENERAL_DATA', response.data.matches);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  },
  async getLiveMatches({ commit }) {
    try {
      const response = await AXIOS.get("v2/match/live", { params: {} });
      if (response.status === 200 && response.data.success) {
        commit('UPDATE_MATCHS_GENERAL_DATA', response.data.matches);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  },
  async getOddsMatches({ commit }) {
    try {
      const response = await AXIOS.get("v2/match/odds", { params: {} });
      if (response.status === 200 && response.data.success) {
        commit('SET_MATCH_ODDS', response.data.matches);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  },
};
